import {createContext} from 'react';

export const FormContext = createContext({
  organisation:{value: "", valid: false},
  email: {value: "", valid:false},
  email_repeat:{value: "", valid: false},
  branch: {value: "", valid: false},
  serial: {value: "", valid: false},
  mac: {value: "", valid: false}
  })